import React from 'react';

import UChips from 'Components/unit/UChips/UChips';
import type { FilterItem } from 'Libs/filter/types';

import styles from './SelectedItemsDisplay.style';

type SelectedItemsDisplayProps = {
  selectedFilters: FilterItem[];
  handleDeleteFilter: (filter: FilterItem) => void;
};

const SelectedItemsDisplay: React.FC<SelectedItemsDisplayProps> = ({ selectedFilters, handleDeleteFilter }) => {
  if (!selectedFilters || selectedFilters.length === 0) {
    return null;
  }

  return (
    <div style={styles.chipsContainer}>
      {selectedFilters.map((filter) => (
        <UChips
          key={`${filter.category}-${filter.id}`}
          type="standard"
          category={filter.category}
          value={filter.value}
          isCloseVisible
          onAction={() => handleDeleteFilter(filter)}
        />
      ))}
    </div>
  );
};

export default SelectedItemsDisplay;
